/** @format */

import template from './gb-fullscreen-toggle.html';
import './gb-fullscreen-toggle.scss';

export const GbFullscreenToggleComponent = {
    template,
    require: {
        gbPresenter: '^^',
    },
    controller: class GbFullscreenToggleComponent {
        constructor() {
            'ngInject';
        }
    },
};
